import { render, staticRenderFns } from "./RatingsViewerError.vue?vue&type=template&id=21389418"
import script from "./RatingsViewerError.vue?vue&type=script&lang=ts"
export * from "./RatingsViewerError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports